module.exports = "<p class=\"alert alert-warning\">\n    <app-spin-icon></app-spin-icon>\n    <span *ngIf=\"orderStart\">Preparing for purchase</span>\n    <span *ngIf=\"paymentPrepare\">Handling payment</span>\n    <span *ngIf=\"orderFinalize\">Finalizing order and setting up tokens</span>\n        <span *ngIf=\"orderComplete\">Order complete! Navigating to complete page</span>\n    <span class=\"ellipses\">...</span>\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/checkout-status-monitor/checkout-status-monitor.component.html
// module id = ./src/app/admin/checkout-status-monitor/checkout-status-monitor.component.html
// module chunks = main